import React from "react";
import { useImage } from "hooks";
import { CardPlaceholder, Loader, MaterialCardMedia } from "components";

interface CardMediaPlaceholderProps {
    url: string;
    width: number;
    onClick?(): void;
}

export const CardMediaPlaceholder = ({ url, width, onClick }: CardMediaPlaceholderProps) => {
    const { isLoaded } = useImage(url);

    if (isLoaded) {
        return <MaterialCardMedia image={url} onClick={onClick} />;
    }

    return (
        <CardPlaceholder width={width}>
            <Loader />
        </CardPlaceholder>
    );
};
